module.exports = __webpack_public_path__ + "media/images/muse_logo-1bb7db06.svg";